import styled from "styled-components";

import { ButtonCustomStyleProps } from "./ButtonCustom";

export const ButtonCustomStyle = styled.div<ButtonCustomStyleProps>`
  width: "max-content";

  & .ant-btn {
    width: ${(props) => props.width && `${props.width}px`};
    transition: all linear 0.2s;
  }

  & .ant-btn-default:not(:disabled) {
    border-color: ${(props) =>
      props.border_color ? props.border_color : props.theme.colors.primary};
    color: ${(props) =>
      props.color ? props.color : props.theme.colors.primary};
    background-color: ${(props) =>
      props.background_color ? props.background_color : "inherit"};
  }

  & .ant-btn-dashed:not(:disabled) {
    border-color: ${(props) =>
      props.border_color ? props.border_color : props.theme.colors.primary};
    color: ${(props) =>
      props.color ? props.color : props.theme.colors.primary};
    background-color: ${(props) =>
      props.background_color ? props.background_color : "inherit"};
  }

  & .ant-btn-text:not(:disabled) {
    color: ${(props) =>
      props.color ? props.color : props.theme.colors.primary};
    background-color: inherit;
  }

  & .ant-btn-link:not(:disabled) {
    color: ${(props) => props.color && props.color};
    background-color: inherit;
  }
  & .ant-btn-ghost:not(:disabled) {
    color: ${(props) => props.color && props.color};
    background-color: inherit;
  }

  & .ant-btn-primary:not(:disabled) {
    background-color: ${(props) =>
      props.background_color
        ? props.background_color
        : props.theme.backgroundColors.second};
    color: ${(props) => (props.color ? props.color : props.theme.text.white)};
    border: none;
    outline: none;
    box-shadow: none;
  }
  & .ant-wave {
    display: none;
  }

  & .ant-btn:not(:disabled):hover {
    opacity: ${(props) => !props.hover_style && 0.8};
    ${(props) => props.hover_style && props.hover_style}
  }

  & .ant-btn:disabled {
    border: none;
    background: #ccc;
    color: ${(props) => props.theme.text.white};
  }
`;
